import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'z-participant-agreement',
  standalone: false,
  styleUrls: ['./participant-agreement.component.scss'],
  templateUrl: './participant-agreement.component.html'
})
export class ParticipantAgreementComponent implements OnInit {

  sanitizedUrl: any;
  readonly updatedDocumentUrl: string = '../../../../assets/PDF Zing Participant Agreement - August 2024.pdf';

  constructor(
    private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.updatedDocumentUrl);
  }
  
}
